<template>
  <el-dialog :visible.sync="visible" width="85%">
    <p class="title">{{language == 'zh'?job.name:job.nameEn}}</p>
    <el-form
      :label-position="labelPosition"
      label-width="80px"
      :model="formLabelAlign"
      :rules="rules"
      ref="ruleForm"
    >
    <div class="firststep" v-if="step == 1">
      <el-row :gutter="120">
        <el-col :xs="24" :sm="24" :md="12" :lg="12">
          <el-form-item :label="language == 'zh'?'姓名':'Name'" class="text" prop="name">
            <el-input v-model="formLabelAlign.name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12"
          ><el-form-item :label="language == 'zh'?'年龄':'Age'" prop="age">
            <el-input v-model.number="formLabelAlign.age"></el-input> </el-form-item
        ></el-col>
      </el-row>
      <el-row :gutter="120">
        <el-col :xs="24" :sm="24" :md="12" :lg="12">
          <el-form-item :label="language == 'zh'?'学历':'Education Degree'" prop="education">
            <el-input v-model="formLabelAlign.education"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12"
          ><el-form-item :label="language == 'zh'?'电话':'Tel.'" prop="tel">
            <el-input v-model="formLabelAlign.tel"></el-input> </el-form-item
        ></el-col>
      </el-row>
      <el-row :gutter="120">
        <el-col :xs="24" :sm="24" :md="12" :lg="12">
          <el-form-item :label="language == 'zh'?'籍贯':'Place of Birth'" prop="nativePlace">
            <el-input v-model="formLabelAlign.nativePlace"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12"
          ><el-form-item :label="language == 'zh'?'现居地':'Place of Living'" prop="residence">
            <el-input v-model="formLabelAlign.residence"></el-input> </el-form-item
        ></el-col>
      </el-row>
      <el-row :gutter="120">
        <el-col :xs="24" :sm="24" :md="12" :lg="12">
          <el-form-item :label="language == 'zh'?'到岗时间':'Arrive Time'" prop="postTime">
            <el-input v-model="formLabelAlign.postTime"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12"
          ><el-form-item :label="language == 'zh'?'期望薪资':'Expected Salary'" prop="salary">
            <el-input v-model="formLabelAlign.salary"></el-input> </el-form-item
        ></el-col>
      </el-row>
      <el-form-item :label="language == 'zh'?'工作经历':'Working Experience'" prop="work">
        <el-input v-model="formLabelAlign.work" type="textarea" placeholder="300字以内"
  :rows="rows"></el-input>
      </el-form-item>
      <p>{{language == 'zh'?'所有带*的选项必需填写，不带*可选填':'All fields marked with * are mandatory, otherwise are optional.'}}</p>
    </div>
    <div v-if='step ==2'>
      <el-form-item :label="language == 'zh'?'项目经历':'Program Description'">
        <el-input v-model="formLabelAlign.project" type="textarea" placeholder="300字以内"
  :rows="rows"></el-input>
      </el-form-item>
      <el-form-item :label="language == 'zh'?'资质证书':'Certificates'">
        <el-input v-model="formLabelAlign.certificate" type="textarea" placeholder="300字以内"
  :rows="rows"></el-input>
      </el-form-item>
      <el-form-item :label="language == 'zh'?'自我评价':'Self Review'">
        <el-input v-model="formLabelAlign.own" type="textarea" placeholder="300字以内"
  :rows="rows"></el-input>
      </el-form-item>
    </div>
    </el-form>
    <el-row style="margin-top:5rem;">
      <el-col :xs="8" :sm="8" :md="8" :lg="3">
        <p class="jobBtn" @click="step = 2" v-if="step == 1">{{language == 'zh'?'下一页':'Next'}}</p>
        <p class="jobBtn"  @click="step = 1" v-if="step == 2">{{language == 'zh'?'上一页':'Previous'}}</p>
      </el-col>
      <el-col :xs="8" :sm="8" :md="8" :lg="19">
      <el-upload
        class="upload-demo"
        :action="action"
        multiple
        :on-remove="onRemove"
        :on-success="onSuccess">
        <p class="jobBtn">{{language == 'zh'?'上传简历':'Upload CV'}}</p>
      </el-upload>
      </el-col>
      <el-col :xs="8" :sm="8" :md="8" :lg="2">
        <p class="jobBtn" @click="submit()">{{language == 'zh'?'提交':'Submit'}}</p>
      </el-col>
    </el-row>
    
  </el-dialog>
</template>
<script>
import qs from'qs'
export default {
  props: {
    id: {
      type: String,
      default: "",
    },
    language: {
        type: String,
        default: ''
      },
    job:{
        type: Object,
        default: {}
      },
  },
  data() {
    return {
      rules: {
          name: [
            { required: true, message: '请输入名称', trigger: 'blur' },
          ],
          age: [
            { required: true, message: '请输入年龄', trigger: 'change' },
            // { message: '请输入数字', type:'number' },
            // { message: '最多输入两位数字', min:2,max:2 , trigger: 'blur'},
          ],
          education: [
            { required: true, message: '请输入学历', trigger: 'blur' }
          ],
          tel: [
            { required: true, message: '请输入电话', trigger: 'blur' }
          ],
          education: [
            { required: true, message: '请输入学历', trigger: 'blur' }
          ],
          nativePlace: [
            { required: true, message: '请输入籍贯', trigger: 'blur' }
          ],
          residence: [
            { required: true, message: '请输入现居地', trigger: 'blur' }
          ],
          postTime: [
            { required: true, message: '请输入到岗日期', trigger: 'blur' }
          ],
          salary: [
            { required: true, message: '请输入期望薪资', trigger: 'blur' }
          ],
          work: [
            { required: true, message: '请输入工作经历', trigger: 'blur' }
          ]
        },
      step:1,
      labelPosition: "top",
      visible: false,
      firstPage:true,//显示第一页
      rows:5,
      formLabelAlign: {
        name: "",
        file: "",
      },
      action:""
    };
  },
  mounted() {
    this.action = this.baseURL+'/hdbs/api/files/upload'
    // this.init();
  },
  methods: {
    init() {
      this.visible = true;
      console.log("init");
    },
    submit(){
      this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            this.formLabelAlign.id = this.job.id
            this.formLabelAlign.job = this.job.name
            this.$http
                .post("/hdbs/api/contacts/apply", 
                    this.formLabelAlign
                  ,{headers: {
                      'Content-Type': 'application/json'
                  }}
                )
                .then(
                  function (response) {
                    var status = response.data.code;
                    if (status === 0) {
                      this.$alert(this.language == 'zh'?'提交成功':'Submitted Successfully', '', {
                        center: true,
                        confirmButtonText: this.language == 'zh'?'确定':'Confirm',
                        callback: action => {
                          this.visible = false
                        }
                      });
                    }
                  }.bind(this)
                )
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      
    },
    onSuccess(response, file){
      this.formLabelAlign.file = response.msg
    },
    onRemove(){
      this.formLabelAlign.file = ''
    }
  },
};
</script>

<style  lang="stylus" scoped>
.html_div {
  min-height: 50rem;
}

.title {
  color: var(--mainBlue);
  font-size: 3.2rem;
  font-family: Demibold;
  margin-bottom:5rem;
}

/deep/ .el-form-item__label {
  color: var(--mainGary);
  font-size: 1.7rem;
  font-family: Regular;
}

/deep/ .el-input__inner {
  background-color: var(--garyEF);
  border: none;
  color: var(--mainBlue);
  font-size: 1.7rem;
  font-family: Regular;
}

/deep/ .el-input__inner:hover {
  //background-color: #fff;
  //box-shadow: 0px 3px 12px rgba(0,0,0,0.12);
  //color:var(--mainGary);
  //border: 1px solid #EAEAEA
}
/deep/ .el-input__inner:focus {
  background-color: #fff;
  box-shadow: 0px 3px 12px rgba(0,0,0,0.12);
  color:var(--mainGary);
  //border: 1px solid #EAEAEA
}

/deep/ .el-textarea__inner {
  background-color: var(--garyEF);
  border: none;
  color: var(--mainBlue);
  font-size: 1.7rem;
  font-family: Regular;
}

/deep/ .el-textarea__inner:hover {
  //background-color: #fff;
  //box-shadow: 0px 3px 12px rgba(0,0,0,0.12);
  //color:var(--mainGary);
}

/deep/ .el-textarea__inner:focus {
  background-color: #fff;
  box-shadow: 0px 3px 12px rgba(0,0,0,0.12);
  color:var(--mainGary);
}

.jobBtn {
  text-align: center;
  width:13rem;
  height:4rem;
  cursor: pointer;
  margin: 0;
  color: #fff;
  background-color: var(--mainBlue);
  line-height: 4rem;
  border-radius: 6px;
  box-shadow: 6px 6px 12px rgba(0, 0, 0, 0.12);
}
/deep/ .el-dialog{
  border-radius: 6px;
  padding:0 9rem;
}
@media screen and (max-width: 1200px) {
  /deep/ .el-dialog{
  padding:0 1rem;
}
}
</style>


// WEBPACK FOOTER //
// src/components/CallUs/SubmitJobDialog.vue